const csCZ = {
  blockRepeater: {
    addNewBlockButton: {
      addBlock: "P\u0159idat blok"
    }
  },
  dataGrid: {
    emptyMessage: {
      text: "\u017D\xE1dn\xE9 polo\u017Eky."
    },
    columnFiltering: {
      showMenuButton: {
        text: "V\u0161echny filtry"
      },
      heading: "V\u0161echny filtry",
      emptyMessage: {
        text: "\u017D\xE1dn\xE9 aktivn\xED filtry."
      },
      columnColumn: {
        text: "Sloupec"
      },
      filterColumn: {
        text: "Filtr"
      },
      addFilterButton: {
        text: "P\u0159idat filtr"
      }
    },
    columnHiding: {
      showMenuButton: {
        text: "Sloupce"
      },
      heading: "Sloupce"
    },
    paging: {
      first: "Prvn\xED",
      previous: "P\u0159edchoz\xED",
      next: "N\xE1sleduj\xEDc\xED",
      last: "Posledn\xED",
      status: {
        unknownPageTotal: "Strana {pageNumber}",
        knownPageTotal: "Strana {pageNumber} z {totalPageCount}",
        itemCount: "({itemCount, plural, =0 {\u017D\xE1dn\xE9 polo\u017Eky} one {# polo\u017Eka} few {# polo\u017Eky} other {# polo\u017Eek}})"
      }
    }
  },
  dataGridCells: {
    includeNull: "Zahrnout nezn\xE1m\xE9",
    booleanCell: {
      includeTrue: "Ano",
      includeFalse: "Ne",
      includeNull: "Nezn\xE1m\xE9"
    },
    dateCell: {
      fromLabel: "Od",
      toLabel: "Do"
    },
    textCell: {
      matches: "Obsahuje",
      doesNotMatch: "Neobsahuje",
      matchesExactly: "P\u0159esn\u011B odpov\xEDd\xE1",
      startsWith: "Za\u010D\xEDn\xE1 na",
      endsWith: "Kon\u010D\xED na",
      queryPlaceholder: "Hledan\xFD v\xFDraz",
      includeNull: "<strong>Zahrnout</strong> pr\xE1zdn\xE9",
      excludeNull: "<strong>Vynechat</strong> pr\xE1zdn\xE9"
    },
    numberCell: {
      equals: "Rovn\xE1 se",
      greaterThan: "V\u011Bt\u0161\xED ne\u017E",
      lessThan: "Men\u0161\xED ne\u017E"
    }
  },
  errorCodes: {
    fieldRequired: "Vypl\u0148te pros\xEDm toto pole.",
    notUnique: "Hodnota nen\xED unik\xE1tn\xED.",
    unknownExecutionError: "Nezn\xE1m\xE1 chyba."
  },
  fieldView: {
    boolean: {
      yes: "Ano",
      no: "Ne"
    },
    fallback: {
      unknown: "Nezn\xE1m\xE9",
      notAvailable: "Pr\xE1zdn\xE9"
    }
  },
  persistFeedback: {
    successMessage: "\xDAsp\u011B\u0161n\u011B ulo\u017Eeno!",
    errorMessage: "P\u0159i ukl\xE1d\xE1n\xED do\u0161lo k chyb\u011B. Zkuste to pros\xEDm znovu.",
    afterPersistErrorMessage: "Po \xFAsp\u011B\u0161n\xE9m ulo\u017Een\xED dat do\u0161lo k chyb\u011B. Obnovte, pros\xEDm, str\xE1nku."
  },
  repeater: {
    addButton: {
      text: "P\u0159idat dal\u0161\xED"
    },
    emptyMessage: {
      text: "Nic tu nen\xED. Zkuste p\u0159idat novou polo\u017Eku."
    }
  },
  upload: {
    addButton: {
      text: "Vyberte soubory z disku",
      subText: "nebo je sem p\u0159et\xE1hn\u011Bte"
    },
    selectButton: {
      text: "Vyberte nahran\xE9 soubory"
    },
    selectModal: {
      maxLimitReached: "Bylo dosa\u017Eeno maxim\xE1ln\xEDho po\u010Dtu polo\u017Eek"
    },
    insertSelected: {
      text: "Vlo\u017Eit vybran\xE9"
    },
    fileState: {
      inspectingFile: "Zkoum\xE1m soubor\u2026",
      invalidFile: "Chybn\xFD soubor",
      failedUpload: "Nahr\xE1v\xE1n\xED selhalo",
      finalizing: "Dokon\u010Duji\u2026"
    }
  },
  editorBlock: {
    editorBlockBoundary: {
      newParagraph: "Nov\xFD odstavec"
    }
  },
  choiceField: {
    createNew: {
      confirmButtonText: "OK",
      cancelButtonText: "Zru\u0161it",
      dialogTitle: "Nov\xE1 polo\u017Eka"
    }
  },
  outdatedApplication: {
    heading: "Nov\xE1 verze je k dispozici",
    text: "Pros\xEDm, obnovte str\xE1nku, abyste mohli vyu\u017E\xEDvat nejnov\u011Bj\u0161\xED funkce aplikace.",
    reloadButton: "Obnovit nyn\xED",
    postponeButton: "Nechat na pozd\u011Bji"
  }
};
export {
  csCZ
};
//# sourceMappingURL=csCZ.js.map
